import type {
  FiPresetRoleKey,
  FiWeeklySummaryPreset,
  FiWeeklySummaryPresetPayload,
} from "@mapmycustomers/shared/types/entity/fieldInsight";

import type { AnalysisConfig } from "@app/component/executiveSummary/types";
import {
  fromBeSettingsCore,
  toFocusAreaPayload,
} from "@app/component/executiveSummary/util/analysisConfigConversion";
import { datasetToApi } from "@app/component/executiveSummary/util/dataset";

export const fromBePreset = (preset: FiWeeklySummaryPreset | undefined): AnalysisConfig =>
  fromBeSettingsCore(preset);

// A preset PUT is a full replace, not a merge: tone, focusAreas and customInstructions must all
// be present, and an omitted dataset is written as null — so every field is sent every time.
export const toBePresetPayload = (
  config: AnalysisConfig,
  roleKey: FiPresetRoleKey
): FiWeeklySummaryPresetPayload => ({
  customInstructions: config.customInstructions,
  dataset: datasetToApi(config.dataset),
  focusAreas: toFocusAreaPayload(config),
  roleKey,
  tone: config.tone,
});
